import { render, staticRenderFns } from "./DualList.vue?vue&type=template&id=11af4781&scoped=true"
import script from "./DualList.vue?vue&type=script&lang=js"
export * from "./DualList.vue?vue&type=script&lang=js"
import style0 from "./DualList.vue?vue&type=style&index=0&id=11af4781&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11af4781",
  null
  
)

export default component.exports